// extracted by mini-css-extract-plugin
export default {"chatContainer":"ChatPage_chatContainer__ej0VN","innerContainer":"ChatPage_innerContainer__KOW1R"};